/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCommentDto
 */
export interface CreateCommentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCommentDto
     */
    wellboreId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentDto
     */
    axis: CreateCommentDtoAxisEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentDto
     */
    dateTimeAxisValue?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCommentDto
     */
    depthAxisValue?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentDto
     */
    mnemonic?: string;
}


/**
 * @export
 */
export const CreateCommentDtoAxisEnum = {
    DateTime: 'DATE_TIME',
    Depth: 'DEPTH'
} as const;
export type CreateCommentDtoAxisEnum = typeof CreateCommentDtoAxisEnum[keyof typeof CreateCommentDtoAxisEnum];


/**
 * Check if a given object implements the CreateCommentDto interface.
 */
export function instanceOfCreateCommentDto(value: object): value is CreateCommentDto {
    if (!('wellboreId' in value) || value['wellboreId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('axis' in value) || value['axis'] === undefined) return false;
    return true;
}

export function CreateCommentDtoFromJSON(json: any): CreateCommentDto {
    return CreateCommentDtoFromJSONTyped(json, false);
}

export function CreateCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCommentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'wellboreId': json['wellboreId'],
        'message': json['message'],
        'axis': json['axis'],
        'dateTimeAxisValue': json['dateTimeAxisValue'] == null ? undefined : json['dateTimeAxisValue'],
        'depthAxisValue': json['depthAxisValue'] == null ? undefined : json['depthAxisValue'],
        'mnemonic': json['mnemonic'] == null ? undefined : json['mnemonic'],
    };
}

export function CreateCommentDtoToJSON(value?: CreateCommentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'wellboreId': value['wellboreId'],
        'message': value['message'],
        'axis': value['axis'],
        'dateTimeAxisValue': value['dateTimeAxisValue'],
        'depthAxisValue': value['depthAxisValue'],
        'mnemonic': value['mnemonic'],
    };
}

